import { colorToHex } from './Color';

export const directions = {
    N: "No change",
    R: "Right",
    U: "Turn around",
    L: "Left",
};

function RuleSettings({ settings, setSettings, antIndex, ruleIndex }) {
    const rule = settings.ants[antIndex].rules[ruleIndex];

    return (
        <div className="accordion-item">
            <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={"#ant_" + antIndex + "_rule_" + ruleIndex}>
                    {rule.direction}
                </button>
            </h2>
            <div id={"ant_" + antIndex + "_rule_" + ruleIndex} className="accordion-collapse collapse" data-bs-parent={"#ant_" + antIndex + "_rules"}>
                <div className="accordion-body">
                    <div className="mb-3">
                        <button
                            className="btn btn-danger" type="button"
                            onClick={() => setSettings({
                                ...settings,
                                reset: true,
                                ants: settings.ants.map((_ant, _antIndex) => {
                                    if (_antIndex === antIndex) {
                                        return {
                                            ..._ant,
                                            rules: _ant.rules.filter((_, _ruleIndex) => _ruleIndex !== ruleIndex),
                                        };
                                    }
                                    return _ant;
                                }),
                            })}
                        >
                            Remove
                        </button>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor={"ant_" + antIndex + "_rule_" + ruleIndex + "_direction"} className="col-4 col-form-label">Direction</label>
                        <div className="col-8">
                            <select
                                className="form-select" id={"ant_" + antIndex + "_rule_" + ruleIndex + "_direction"}
                                value={rule.direction}
                                onChange={(e) => setSettings({
                                    ...settings,
                                    reset: true,
                                    ants: settings.ants.map((_ant, _antIndex) => {
                                        if (_antIndex === antIndex) {
                                            return {
                                                ..._ant,
                                                rules: _ant.rules.map((_rule, _ruleIndex) => {
                                                    if (_ruleIndex === ruleIndex) {
                                                        return {
                                                            ..._rule,
                                                            direction: e.target.value,
                                                        };
                                                    }
                                                    return _rule;
                                                }),
                                            };
                                        }
                                        return _ant;
                                    }),
                                })}
                            >
                                {Object.keys(directions).map(direction => (
                                    <option key={direction} value={direction}>
                                        {directions[direction]}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="mb-3 row">
                        <label htmlFor={"ant_" + antIndex + "_rule_" + ruleIndex + "_color"} className="col-4 col-form-label">Color</label>
                        <div className="col-8">
                            <select
                                className="form-select" id={"ant_" + antIndex + "_rule_" + ruleIndex + "_color"}
                                style={{ backgroundColor: colorToHex(settings.colorScheme[rule.color]) }}
                                value={rule.color}
                                onChange={(e) => setSettings({
                                    ...settings,
                                    reset: true,
                                    ants: settings.ants.map((_ant, _antIndex) => {
                                        if (_antIndex === antIndex) {
                                            return {
                                                ..._ant,
                                                rules: _ant.rules.map((_rule, _ruleIndex) => {
                                                    if (_ruleIndex === ruleIndex) {
                                                        return {
                                                            ..._rule,
                                                            color: e.target.value,
                                                        };
                                                    }
                                                    return _rule;
                                                }),
                                            };
                                        }
                                        return _ant;
                                    }),
                                })}
                            >
                                {settings.colorScheme.map((color, colorIndex) => (
                                    <option key={colorIndex} value={colorIndex} style={{ backgroundColor: colorToHex(color) }} />
                                ))}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function randomDirection() {
    return Object.keys(directions)[Math.floor(Math.random() * Object.keys(directions).length)];
}

export default RuleSettings;
